import React, {FunctionComponent} from 'react';
import {languagesFlagsRefs} from '../NotificationEditor/components/NotificationEditorContent';

interface InputLabelEditorProps {
  title: string;
  isRequired?: boolean;
  flag?: string;
}
export const InputLabelEditor: FunctionComponent<InputLabelEditorProps> = ({
  title,
  isRequired,
  flag,
}) => {
  return (
    <div
      style={{
        fontSize: 14,
        color: '#696773',
        marginBottom: 8,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
      }}>
      {flag && (
        <span
          style={{height: 22, width: 22, borderRadius: 22, marginRight: 8}}
          className={`flag-icon flag-icon-${languagesFlagsRefs[flag]} flag-icon-squared`}
        />
      )}
      <div>{title}</div>
      {isRequired && <span style={{color: 'red'}}> *</span>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/InputLabelEditor/index.tsx